<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="treeview-modal-body">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" cdkDropList (cdkDropListDropped)="dropItem($event)" [cdkDropListData]="dataSource">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding cdkDrag [cdkDragData]="node">
        <button mat-icon-button disabled></button>
        <span>{{node.name}}</span>
      </mat-tree-node>
      <mat-tree-node
        [ngClass]="{'selected': selectedItem.id == node.id }"
        (click)="selectItem(node, $event)" (dblclick)="expandItemByDblclick(node, $event)"
        *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding
        cdkDrag [cdkDragData]="node">
        @if (!node.checked || !node.hasChild) {
          <button mat-icon-button disabled></button>
          @if (!node.checked) {
            <mat-icon  class="mark-icon" [inline]="true">folder_open</mat-icon>
          }
          @if (node.checked && !node.hasChild) {
            <mat-icon  class="mark-icon" [inline]="true">folder</mat-icon>
          }
          <span>{{node.name}}</span>
        }
        @if (node.checked && node.hasChild) {
          <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-icon class="mark-icon" [inline]="true">folder</mat-icon>
          <span>{{node.name}}</span>
        }
        @if (node.isLoading) {
          <mat-progress-spinner
            class="loadingSpinner"
            mode="indeterminate"
            value="40"
            diameter="20"
            >
          </mat-progress-spinner>
        }
      </mat-tree-node>
    </mat-tree>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center">
    <button mat-raised-button color="primary" (click)="onClickClose()">Close</button>
  </div>
</div>
